const guide = {
  moreInfo: "Подробнее",
  example: "Пример",
  askAI: "Спросить AI",
  editHint: "Правый клик для редактирования",
  supports: "Поддерживаемые свойства",
  colors: "Цвета",
  typography: "Типографика",
  text: "Текст",
} as const;
export default guide;
